/**
 * Part of simular project.
 *
 * @copyright  Copyright (C) 2022 __ORGANIZATION__.
 * @license    __LICENSE__
 */

$(() => {
  const $window = $(window);
  const $slider = $('.c-service-slider');
  let $icons = $('.c-serve-item');

  $slider.addClass('owl-carousel owl-theme').children().addClass('item');

  const $owl = $slider.owlCarousel({
    items: 1,
    stagPadding: 60,
    margin: 30,
    center: true
  });

  $owl.on('changed.owl.carousel', (e) => {
    $icons.removeClass('active');

    const $icon = $($icons.get(e.item.index));

    $icon.addClass('active');
  });

  $icons.on('click', (e) => {
    e.preventDefault();
  });

  $icons.on('mouseenter', (e) => {
    const $this = $(e.currentTarget);

    $owl.trigger('to.owl.carousel', [$icons.index($this)]);
  });

  $slider.find('.c-service-slider-item').on('click',(e) => {
    const index = $('.c-service-slider-item').index($(e.currentTarget));

    $owl.trigger('to.owl.carousel', [index]);
  });

  $window.on('resize', () => {
      let stagePadding = ($window.width() - 800) / 2;

      if (stagePadding < 60) {
        stagePadding = 60;
      }

      $slider.data('owl.carousel').options.stagePadding = stagePadding;
      $slider.data('owl.carousel').settings.stagePadding = stagePadding;

      $owl.trigger('refresh.owl.carousel');
    })
    .trigger('resize');
});
